import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block2() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <div className="row grid-base align-items-center">
                        <div className="image-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/bureau.jpg" alt="bureau" className="homepage"/>
                            </figure>
                        </div>

                        <div className="content-column col-xl-6 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">Un espace centralisé pour <span>l’accès à des ressources utiles</span></h2>
                                </div>
                                <div className="text">
                                    Un espace où vos collaborateurs ont accès à <span>des informations centralisées</span> pour toutes leurs interrogations sur le <span>handicap au travail</span> et particulièrement sur <span>le handicap dans votre entreprise.</span>
                                    <ul className="list-style-two homepage">
                                        <li>Présentation de votre politique handicap </li>
                                        <li>Les contacts utiles internes et externes</li>
                                        <li>Foire Aux Questions (FAQ) personnalisée</li>
                                    </ul>
                                </div>

                                {/*<motion.button
                                        className="theme-btn btn-style-one small"
                                        initial={{opacity: 0, y: 0}}
                                        animate={{opacity: 1, y: 20}}
                                        transition={{delay: 1.0, duration: 1.5}}
                                        data-cal-namespace="ligne-inclusion"
                                        data-cal-link="team/talents-handicap/ligne-inclusion"
                                        data-cal-config='{"layout":"month_view"}'
                                >Réserver un créneau
                                </motion.button>*/}

                                <ContactModal textButton="Demander un devis" showText={false} small="small"
                                              linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block2;
